/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Lustrace_SummaryInputs */

const cs_property_lustrace_summary = /** @type {(inputs: Property_Lustrace_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Souhrn lustrace`)
};

const en_property_lustrace_summary = /** @type {(inputs: Property_Lustrace_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lustrace summary`)
};

/**
* | output |
* | --- |
* | "Lustrace summary" |
*
* @param {Property_Lustrace_SummaryInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_lustrace_summary = /** @type {((inputs?: Property_Lustrace_SummaryInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Lustrace_SummaryInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_lustrace_summary(inputs)
	return cs_property_lustrace_summary(inputs)
});